<template>
  <div>
    <div class="row align-items-center mb-2">
      <div class="col-md-8">
        <p class="mb-0 text-muted" style="font-size: 12px">
          <router-link to="/assuntos" class="text-muted">Assuntos</router-link>
          <span v-if="assunto"> / {{ assunto.nome }}</span>
        </p>
        <h3 class="mb-0 mt-1 font-weight-bold" v-if="assunto">
          <i class="fa fa-folder-open text-primary mr-2" style="font-size: 20px"></i>{{ assunto.nome }}
        </h3>
      </div>
      <div class="col-md-4 text-right">
        <router-link to="/assuntos" class="btn btn-back mr-1">
          <i class="fa fa-arrow-left"></i> Voltar
        </router-link>
        <router-link
          :to="'/documentos/add' + (assunto_id ? '?assunto_id=' + assunto_id : '')"
          class="btn btn-add"
        >
          <i class="fa fa-plus"></i> Novo Documento
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'documentosCrud'"
          crudName="Documentos"
          newText="Novo Documento"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="true"
          :enableView="true"
          :enableReset="false"
          :dataForm="dataForm"
          @view="abrirDocumento"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data() {
    const assunto_id = this.$route.query.assunto_id || null;
    return {
      table: "documentosTable",
      assunto_id: assunto_id,
      assunto: null,
      endPoint: "documentos",
      dataForm: {},
      columns: ["id", "titulo", "extensao", "nome_original", "actions"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "titulo"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 15,
        perPageValues: [15, 25, 50, 100],
        headings: {
          id: "ID",
          titulo: "Título",
          extensao: "Tipo",
          nome_original: "Arquivo",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          extensao: function (h, row) {
            const icones = {
              pdf: "fa-file-pdf-o text-danger",
              xlsx: "fa-file-excel-o text-success",
              xls: "fa-file-excel-o text-success",
              docx: "fa-file-word-o text-primary",
              doc: "fa-file-word-o text-primary",
              pptx: "fa-file-powerpoint-o text-warning",
              ppt: "fa-file-powerpoint-o text-warning",
              jpg: "fa-file-image-o text-info",
              jpeg: "fa-file-image-o text-info",
              png: "fa-file-image-o text-info",
              gif: "fa-file-image-o text-info",
            };
            const ext = (row.extensao || "").toLowerCase();
            const cls = icones[ext] || "fa-file-o text-secondary";
            return h("span", [
              h("i", { class: "fa " + cls + " mr-1" }),
              (row.extensao || "—").toUpperCase(),
            ]);
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["assunto"];

          const assunto_id = this.$parent.$parent.$parent.assunto_id;
          if (assunto_id) {
            requestData.params.assunto_id = assunto_id;
          }

          return axios
            .get(this.url + "?" + query, requestData)
            .catch(function (e) {
              this.dispatch("error", e);
            }.bind(this));
        },
      },
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    abrirDocumento(id) {
      this.$router.push("/documentos/view/" + id);
    },

    query(query) {
      let columns = { id: "id", titulo: "titulo" };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },

    getAssunto(id) {
      const self = this;
      axios
        .get(self.$store.state.api + "assuntos/" + id)
        .then((response) => {
          self.assunto = response.data.data[0];
        })
        .catch(() => {});
    },
  },
  mounted() {
    if (this.assunto_id) {
      this.getAssunto(this.assunto_id);
    }
  },
};
</script>

<style>
.dark-layout .VueTables__table tbody tr:nth-of-type(odd) {
  background-color: #283046;
}
.dark-layout .VueTables__table tbody tr:nth-of-type(even) {
  background-color: #242b3d;
}
.dark-layout .VueTables__table tbody tr:hover {
  background-color: #3b4253;
}
</style>
